import React from 'react';
import { Image, Platform, StyleSheet } from 'react-native';

// Native SVG imports (only loaded on native platforms)
// @ts-ignore - Platform-specific import
import FindAChargerSvg from '../../../assets/navMenu/findACharger.svg';
// @ts-ignore - Platform-specific import
import ChargingHistorySvg from '../../../assets/navMenu/chargingHistory.svg';
// @ts-ignore - Platform-specific import
import ChargerDashboardSvg from '../../../assets/navMenu/chargerDashboard.svg';
// @ts-ignore - Platform-specific import
import ChargerInsightsSvg from '../../../assets/navMenu/chargerInsights.svg';
// @ts-ignore - Platform-specific import
import PartnerPortalSvg from '../../../assets/navMenu/partnerPortal.svg';
// @ts-ignore - Platform-specific import
import EarningsDashboardSvg from '../../../assets/navMenu/earningsDashboard.svg';
// @ts-ignore - Platform-specific import
import MyAccountSvg from '../../../assets/navMenu/myAccount.svg';
// @ts-ignore - Platform-specific import
import HelpCenterSvg from '../../../assets/navMenu/helpCenter.svg';
// @ts-ignore - Platform-specific import
import AboutSvg from '../../../assets/navMenu/about.svg';
// @ts-ignore - Platform-specific import
import SignOutSvg from '../../../assets/navMenu/signOut.svg';
// @ts-ignore - Platform-specific import
import SignInOrSignUpSvg from '../../../assets/navMenu/signInOrSignUp.svg';

// PNG imports for web
const findAChargerPng = require('../../../assets/navMenu/findACharger.png');
const chargingHistoryPng = require('../../../assets/navMenu/chargingHistory.png');
const chargerDashboardPng = require('../../../assets/navMenu/chargerDashboard.png');
const chargerInsightsPng = require('../../../assets/navMenu/chargerInsights.png');
const partnerPortalPng = require('../../../assets/navMenu/partnerPortal.png');
const earningsDashboardPng = require('../../../assets/navMenu/earningsDashboard.png');
const myAccountPng = require('../../../assets/navMenu/myAccount.png');
const helpCenterPng = require('../../../assets/navMenu/helpCenter.png');
const aboutPng = require('../../../assets/navMenu/about.png');
const signOutPng = require('../../../assets/navMenu/signOut.png');
const signInOrSignUpPng = require('../../../assets/navMenu/signInOrSignUp.png');

export type MenuIconName =
  | 'findACharger'
  | 'chargingHistory'
  | 'chargerDashboard'
  | 'chargerInsights'
  | 'partnerPortal'
  | 'earningsDashboard'
  | 'myAccount'
  | 'helpCenter'
  | 'about'
  | 'signOut'
  | 'signInOrSignUp';

interface MenuIconProps {
  name: MenuIconName;
  size?: number;
  color?: string;
}

// Map icon names to their respective components/sources
const iconMap: Record<MenuIconName, { svg: any; png: any }> = {
  findACharger: { svg: FindAChargerSvg, png: findAChargerPng },
  chargingHistory: { svg: ChargingHistorySvg, png: chargingHistoryPng },
  chargerDashboard: { svg: ChargerDashboardSvg, png: chargerDashboardPng },
  chargerInsights: { svg: ChargerInsightsSvg, png: chargerInsightsPng },
  partnerPortal: { svg: PartnerPortalSvg, png: partnerPortalPng },
  earningsDashboard: { svg: EarningsDashboardSvg, png: earningsDashboardPng },
  myAccount: { svg: MyAccountSvg, png: myAccountPng },
  helpCenter: { svg: HelpCenterSvg, png: helpCenterPng },
  about: { svg: AboutSvg, png: aboutPng },
  signOut: { svg: SignOutSvg, png: signOutPng },
  signInOrSignUp: { svg: SignInOrSignUpSvg, png: signInOrSignUpPng },
};

const MenuIcon: React.FC<MenuIconProps> = ({ name, size = 24, color }) => {
  const iconData = iconMap[name];

  if (!iconData) {
    console.warn(`MenuIcon: Unknown icon name "${name}"`);
    return null;
  }

  if (Platform.OS === 'web') {
    // Use PNG for web
    return (
      <Image
        source={iconData.png}
        style={[
          { width: size, height: size },
          color ? { tintColor: color } : null,
        ]}
        resizeMode="contain"
      />
    );
  }

  // Use SVG for native
  const SvgIcon = iconData.svg;
  return <SvgIcon width={size} height={size} fill={color} />;
};

export default MenuIcon;

